export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [{
        slots: {
          title: '保障权益'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '保障金额'
        },
        dataIndex: 'value',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '权益说明'
        },
        dataIndex: 'info',
        key: '3',
        align: 'center'
      }]
    };
  }
};